<script lang="ts">
    
    import type { State } from "../../Model/State";
    import { pictureUrlFactory } from "../../Services";

    export let id: State<string | null>;

    let pictureUrl: string;

    $: setupPictureUrl($id);

    function setupPictureUrl(pictureId: string | null): void {
        pictureUrl = pictureId
            ? pictureUrlFactory.getPictureUrl(pictureId)
            : '/images/default-placeholder.png';
    }

    function setDefault() {
        pictureUrl = '/images/default-placeholder.png';
    }

</script>

<!-- svelte-ignore a11y-missing-attribute -->
<img src={pictureUrl} on:error={setDefault}>

<style lang="scss">

    img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

</style>
